import React from 'react';
import { object } from 'prop-types';
import './advances-declines-table.m.css';

const AdvancesDeclinesTable = ({ data }) => {
  const indices = data?.indices;

  return (
    <table styleName="table-container">
      <thead>
        <tr styleName="header-row">
          <th styleName="table-header">INDICES</th>
          <th styleName="table-header-alt">CHANGE</th>
          <th styleName="table-header-alt">ADVANCES</th>
          <th styleName="table-header-alt">DECLINES</th>
        </tr>
      </thead>
      <tbody>
        {indices?.map((indice, index) => (
          <tr key={index} styleName="container-row">
            <td styleName="table-data">{indice.isname}</td>
            <td styleName="table-data-change">
              {indice.chgp.toString().includes('-') ? (
                <span styleName="negative">&#x25BC; {Math.abs(indice.chgp)}%</span>
              ) : (
                <span styleName="positive">&#x25B2; {indice.chgp}%</span>
              )}
            </td>
            <td styleName="adv-dec">{indice.adv}</td>
            <td styleName="adv-dec">{indice.dec}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

AdvancesDeclinesTable.propTypes = {
  data: object
};

export default AdvancesDeclinesTable;
